import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessGranted: false,
    username: '',
    env: ''
  },
  mutations: {
    checkAccess: (state, creds) => {
      state.accessGranted = creds
    },
    displayName: (state, userName) => {
      state.username = userName
    },
    checkENV: (state) => {
      if (process.env.NODE_ENV === 'development') {
        state.env = '-dev'
      } else {
        state.env = ''
      }
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
